import { useOutletContext } from "react-router-dom";
import { Flex } from "antd";
import { AppForm, AppLoader } from "@/shared/Components";
import { useGeneralInfoTab } from "@/entities/general-info-tab-content/model";
import { AddressesList } from "../addresses-list";
import { AnniversariesList } from "../anniversaries-list";
import { EmailsList } from "../emails-list";
import { LinksList } from "../links-list";
import { PhonesList } from "../phones-list";
import { SocialNetworksList } from "../social-networks-list";
import styles from "./styles.module.scss";

const defaultContext = {
  isEditMode: false,
  handleEditMode: () => {},
};

export const GeneralInfoDesktop = () => {
  const { isEditMode, handleEditMode } =
    useOutletContext<{
      isEditMode: boolean;
      handleEditMode: () => void;
    }>() ?? defaultContext;

  const { state, methods } = useGeneralInfoTab(isEditMode);

  const { isLoading, form, personId, addDisabled } = state;
  const { handleSubmit } = methods;

  if (isLoading) {
    return <AppLoader />;
  }

  return (
    <div className={styles.container}>
      <AppForm formApi={form} onSubmit={handleSubmit}>
        <Flex wrap="wrap" gap="clamp(2rem, 5vw, 4rem)">
          <PhonesList
            personId={personId ?? ""}
            isEditMode={isEditMode}
            handleEditMode={handleEditMode}
            onSubmit={handleSubmit}
            disabled={addDisabled}
          />
          <EmailsList
            personId={personId ?? ""}
            isEditMode={isEditMode}
            handleEditMode={handleEditMode}
            onSubmit={handleSubmit}
            disabled={addDisabled}
          />
          <LinksList
            personId={personId ?? ""}
            isEditMode={isEditMode}
            handleEditMode={handleEditMode}
            onSubmit={handleSubmit}
            disabled={addDisabled}
          />
          <SocialNetworksList
            personId={personId ?? ""}
            isEditMode={isEditMode}
            handleEditMode={handleEditMode}
            onSubmit={handleSubmit}
            disabled={addDisabled}
          />
          <AddressesList
            personId={personId ?? ""}
            isEditMode={isEditMode}
            handleEditMode={handleEditMode}
            onSubmit={handleSubmit}
            disabled={addDisabled}
          />
          <AnniversariesList
            personId={personId ?? ""}
            isEditMode={isEditMode}
            handleEditMode={handleEditMode}
            onSubmit={handleSubmit}
            disabled={addDisabled}
          />
        </Flex>
      </AppForm>
    </div>
  );
};
